import React, { useState, useRef } from "react";
import { Steps, message } from "antd";
import "./style.css";
import CustomerOnBoarding from "../CustomerOnBoarding";
import EmergencyContact from "../EmergencyContact";
import VehicleInformation from "../VehicleInformation";
import SetUpPointsOfInterest from "../SetUpPointsOfInterest";
import SetNoGoOrUse from "../SetNoGoOrUse";
import { createCustomer, truncateFileName } from "../../../API/User/customer";

const { Step } = Steps;

const AddCustomerList = () => {
  const [current, setCurrent] = useState(0);
  const [customerData, setCustomerData] = useState({});
  const [emergencyData, setEmergencyData] = useState({});

  const [messageApi, contextHolder] = message.useMessage();

  const steps = [{}, {}, {}];

  const handleStep1Next = (data) => {
    setCustomerData(data);
    setCurrent(1);
  };

  const handleStep2Next = async (data) => {
    try {
      setEmergencyData(data);

      const formData = new FormData();

      formData.append("customer_name", customerData?.customerName);
      formData.append(
        "customer_phone",
        customerData?.customerPhone?.startsWith("+")
          ? customerData.customerPhone
          : `+${customerData.customerPhone}`,
      );
      formData.append("email", customerData?.email);
      formData.append("api_key", customerData?.api_key);
      formData.append("domain", customerData?.domain);
      formData.append("secret_pin", customerData?.pin);

      const logoFile = customerData.logo?.[0]?.originFileObj;
      if (logoFile) {
        formData.append(
          "customer_profile_picture",
          logoFile,
          truncateFileName(logoFile.name),
        );
      }

      formData.append("emergency_contact_person", data?.personName);
      formData.append(
        "emergency_contact_phone",
        data?.personPhone?.startsWith("+")
          ? data.personPhone
          : `+${data.personPhone}`,
      );
      formData.append("recovery_company_id", data?.recoveryCompany);

      const createdCustomer = await createCustomer(formData);

      if (createdCustomer?.customer?.id) {
        setCustomerData((prev) => ({
          ...prev,
          id: createdCustomer.customer.id,
        }));
      }

      messageApi.success("Customer created successfully");

      setCurrent(2);
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        Object.values(error?.response?.data || {})?.[0]?.[0] ||
        "Failed to create customer";

      messageApi.error(errorMsg);
    }
  };

  return (
    <div className="add-customer">
      {contextHolder}
      <div className="steps-container">
        <Steps current={current} className="steps-bar">
          {steps.map((s, i) => (
            <Step key={i} title={s.title} />
          ))}
        </Steps>
      </div>
      {current === 0 && (
        <CustomerOnBoarding
          onNext={handleStep1Next}
          initialValues={customerData}
        />
      )}

      {current === 1 && (
        <EmergencyContact
          onNext={handleStep2Next}
          onCancel={() => setCurrent(0)}
          initialValues={emergencyData}
        />
      )}

      {current === 2 && (
        <VehicleInformation
          propCustomerId={customerData?.id}
          onNext={() => setCurrent(3)}
          onCancel={() => setCurrent(1)}
        />
      )}
      {/* {current === 3 && (
        <SetUpPointsOfInterest
          geofenceList={geofenceList}
          setGeofenceList={setGeofenceList}
          onNext={() => setCurrent(4)}
          onCancel={() => setCurrent(2)}
        />
      )}
      {current === 4 && <SetNoGoOrUse onCancel={() => setCurrent(3)} />} */}
    </div>
  );
};

export default AddCustomerList;
